import { Component, Input, OnInit, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-new-success-popup',
    templateUrl: './new-success-popup.component.html',
    styleUrls: ['./new-success-popup.component.scss'],
    standalone: false
})
export class NewSuccessPopupComponent implements OnInit {
  constructor(
    private router: Router,
    @Optional() public dialogRef: MatDialogRef<NewSuccessPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  @Input() successmessage: string = "";
  @Input() closebuttonin: any;
  @Output() changeOutput: EventEmitter<any> = new EventEmitter<any>();
  page: number = 1;
  adduserpage = 1;
  modelWidth = 900;

  ngOnInit(): void {
    if (this.data && this.data.successmessage) {
      this.successmessage = this.data.successmessage;
    }
  }

  cancelModel() {
    this.changeOutput.emit(true);
    if (this.dialogRef) {
      this.dialogRef.close(true);
    }
    this.router.navigate(['/dash/system-users']);
  }

}
